import { Arrow } from 'assets/SVG';
import { ButtonGroup, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import PageHeading from './shared/PageHeading';
import { Link } from 'react-scroll';
function CardCustom({ image, icon, heading, title, para }) {
  return (
    <Card className="shadow-sm rounded-4 border-0 p-4 pb-2 h-100 ">
      <Card.Img variant="top" src={image} className="img-fluid rounded-4" />
      <Card.Body className="d-flex flex-column">
        <Card.Title className="my-3">
          <PageHeading heading={title} image={icon} />
        </Card.Title>

        <div className="flex-grow-1">
          {para && <p>{para}</p>}
          {heading && (
            <h6>
              <strong>
                <i>{heading}</i>
              </strong>
            </h6>
          )}
        </div>

        <Col xl={4} md={6} xs={12} className="mt-md-5 mt-auto">
          <ButtonGroup className="d-flex btn-group">
            <Link
              to="Connect"  // Matches the "name" in the Element
              smooth={true}  // Smooth scrolling effect
              duration={500} // Duration of the scroll (in milliseconds)
            >
              <Button className="btn-custom px-4">
                <small>Learn More</small>
              </Button>
            </Link>
            <span className="arrow">
              <Arrow />
            </span>
          </ButtonGroup>
        </Col>
      </Card.Body>
    </Card>
  );
}

export default CardCustom;
